var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloudformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    focusable: "false",
    width: "32px",
    height: "32px",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "0 0 256 312",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.491 215.53l2.176 2.47l109.915 31.157l.498-19.313l-76.98-19.318l-3.767-1.359l-31.842 6.363",
    fill: "#B7CA9D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M239.505 215.53L127.25 253l-.334-23.156l76.979-19.318l3.355-3.776l32.255 8.78",
    fill: "#B7CA9D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M126.916 83.165l76.979 17.941L237.75 99.5l1.755-3.393L132.25 57.5l-5.334 25.665",
    fill: "#3C4929"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M52.1 210.526l-35.609 5.004l-.991-3.697V100l.991-3.893L48.667 98.5l3.433 2.61v109.416",
    fill: "#759C3E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M129.08 83.165L52.1 101.106l-35.609-4.999L17.833 94l110.749-31.52l.498 20.685",
    fill: "#3C4929"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M127.846 0L0 64.531l.061 182.613l127.785 64.497l1.904-2.891v-305L127.846 0zM90.462 237.73l-73.971-22.2V96.107l73.971-22.192V237.73z",
    fill: "#4B612C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M203.895 210.526l35.61 5.004L241.5 212V99.5l-1.995-3.393l-35.61 5.003v109.416",
    fill: "#4B612C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M127.846 311.641l128.093-64.493L256 64.536L127.846 0v311.641zm37.687-237.726l73.972 22.192V215.53l-73.972 22.2V73.915z",
    fill: "#759C3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloudformation);
export default __webpack_public_path__ + "static/media/cloudformation.24cc27eb.svg";
export { ForwardRef as ReactComponent };